import { Paper, Slider, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { imageSectionMobileHeightPx } from 'artkive/pages/Pricing/ImageTextSection'
import { BREAKPOINTS } from 'artkive/utils/constants'

export const ImageBox = styled('div')(({ theme }) => ({
  height: '100%',
  position: 'relative',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    height: `${imageSectionMobileHeightPx}px`,
    '& picture > img': {
      height: '100%',
    },
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    textAlign: 'center',
  },
}))

export const BulletsBox = styled('div')({
  marginTop: '24px',
  marginBottom: '32px',
})

export const CostHint = styled(Paper)(({ theme }) => ({
  '&&': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  height: 74,
  border: '2px solid #E6F1FC',
  borderRadius: 8,
  padding: '0 8px',
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    width: 120,
    textAlign: 'right',
  },
}))

export const Price = styled(Typography)({
  fontSize: '1.5rem',
  lineHeight: 1.5,
})

export const Separator = styled(Typography)({
  padding: '0 12px',
})

export const SliderBox = styled('div')({
  paddingLeft: '16px',
  paddingRight: '16px',
  marginTop: '24px',
  marginBottom: '24px',
  flex: 1,
  width: '100%',
})

export const CustomSlider = styled(Slider)({
  '& .MuiSlider-rail': {
    left: -16,
    right: -16,
    width: 'calc(100% + 32px)',
  },
  '& .MuiSlider-track': {
    transform: 'translateX(-16px)',
  },
})

export const ButtonBox = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'left',
  marginTop: '48px',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    justifyContent: 'center',
    marginTop: '40px',
  },
}))
